import React from "react";
import localize from "../../../../../../../core/utils/translation-files";
import { BandScaleTableResponse } from "../../../../../../../core/contracts/bandScale/bandScaleContract";
import CustomTable from "../../../../../../../layout/components/customTable";
const TrackedItemBandScaleTable = ({ data, tableRef, subCategory }) => {
    const bandRanges = {
        A: "90% - 100%",
        B: "80% - 90%",
        C: "70% - 80%",
        D: "0% - 70%",
    };
    const columns = [
        {
            fieldName: "bandName",
            title: ["TrackedItemsScale.bandName"],
            width: 100,
            render(bandName, record) {
                return {
                    props: {
                        style: { background: record.rgbColor + "80" },
                    },
                    children: React.createElement("div", null, bandName),
                };
            },
        },
        {
            fieldName: "bandName",
            title: ["TrackedItemsScale.scaleRangeHeading"],
            width: 100,
            render(bandName, record) {
                // console.log(bandName,record)
                return {
                    props: {
                        style: { background: record.rgbColor + "80" },
                    },
                    children: React.createElement("div", null, bandRanges[bandName]),
                };
            },
        },
        {
            fieldName: "title",
            title: ["TrackedItemsScale.riskBand"],
            width: 210,
            render(title, record) {
                return {
                    props: {
                        style: { background: record.rgbColor + "80" },
                    },
                    children: React.createElement("div", null, title),
                };
            },
        },
    ];
    return (React.createElement("div", { "data-test": "scaleTableComponent", ref: tableRef },
        React.createElement("h3", { className: "d-print page-title" }, localize(["TrackedItemsScale.scaleTableHeading"])),
        React.createElement(CustomTable, { data: data, columns: columns, dataType: BandScaleTableResponse, scroll: false })));
};
export default TrackedItemBandScaleTable;
